// citiSignOut is an ajax (jsonp) call towards citi that signs the user out.
// This requires a baseUrl which generally comes from partnerBaseFusionUrl
const citiSignOut = (baseUrl) => {
  // Create script with url
  const ref = document.getElementsByTagName('script')[0];
  const script = document.createElement('script');
  script.src = `${baseUrl}/RSnextgen/svc/launch/signon.action?callback=Callback&mode=signoff`;

  // After the script is loaded and executed, remove it
  script.onload = function () {
    this.remove();
  };

  // Insert script tag into the DOM (append to head)
  ref.parentNode.insertBefore(script, ref);
};

/* eslint-disable */
export {
  citiSignOut
};
/* eslint-enable */
